import React from 'react';

const ErrorMessageDetails = ({ children }) => (
  <div className="error-message-details">{children}</div>
);

export default ErrorMessageDetails;
